/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
import React, { Component } from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'util/PropTypes';
import StringResources from 'nls/StringResources';
import { SVGIcon, Label } from 'ca-ui-toolkit';

import dataRelationships128 from '@ba-ui-toolkit/ba-graphics/dist/illustrations-js/data-relationships-card_128';

import BlankCardView from './views/BlankCardView';

import './AddNewCard.scss';

@observer
class AddNewCard extends Component {

	constructor(props) {
		super(props);
	}

	render() {
		const menuItems = this.getMenuSpec();

		return (
			<div className="explore-add-new__content">
				{menuItems}
			</div>
		);
	}

	renderItem(item, key) {
		let menuItem;
		if (item.icon) {
			menuItem = (
				<div
					className="explore-add-new__content__item"
					onClick={() => this.onClick(item.type)}
					key={key}
					data-type={item.type}
				>
					<div
						className="explore-add-new__content__item__icon"
						onKeyPress={(...params) => this.onKeyPress(item.type, ...params)}
						tabIndex={0}
					>
						<SVGIcon className={`${item.className ? item.className : ''}`} width={128} height={100} iconId={item.icon.id} />
					</div>
					<Label className="explore-add-new__content__item__caption" label={item.caption} />
				</div>
			);
		} else {
			menuItem = item.element(key);
		}

		return menuItem;
	}

	onClick(type) {
		this.performAction(type);
	}

	onEnter(type) {
		this.performAction(type);
	}

	onKeyPress(type, event) {
		const handler = {
			'Enter': () => this.onEnter(type)
		}[event.key];

		handler && handler();
	}

	performAction(type) {
		this.props.onClick({ type });
	}

	getMenuSpec() {
		const spec = [
			{
				element: key => <div
					className="explore-add-new__content__item explore-add-new__content__item__single"
					onClick={() => this.onClick('single')}
				>
					<div
						className="explore-add-new__content__item__icon"
						onKeyPress={(...params) => this.onKeyPress('single', ...params)}
						tabIndex={0}
					>
						<BlankCardView
							classPrefix={'explore-add-new__content__item__icon__card'}
							key={key}
						/>
					</div>
					<Label className="explore-add-new__content__item__caption" label={StringResources.get('flyout_add-new-card_single')} />
				</div>,
				type: 'single'
			},
			{
				element: key => <div
					className="explore-add-new__content__item explore-add-new__content__item__compare"
					onClick={() => this.onClick('compare')}
				>
					<div
						className="explore-add-new__content__item__icon"
						onKeyPress={(...params) => this.onKeyPress('compare', ...params)}
						tabIndex={0}
					>
						<BlankCardView
							classPrefix={'explore-add-new__content__item__icon__card'}
							key={`${key}_1`}
						/>
						<BlankCardView
							classPrefix={'explore-add-new__content__item__icon__card'}
							key={`${key}_2`}
						/>
					</div>
					<Label className="explore-add-new__content__item__caption" label={StringResources.get('flyout_add-new-card_compare')} />
				</div>,
				type: 'compare'
			},
			{
				caption: '',
				element: key => <div className="explore-add-new__separator" key={key} />,
				type: 'separator'
			},
			{
				caption: '',
				element: key => <Label className="explore-add-new__label" label={StringResources.get('flyout_add-new-card_goTo_startingPoints')} key={key} />,
				type: 'label'
			},
			{
				caption: StringResources.get('startingPoints_data_relationships_thumbnail_title'),
				icon: dataRelationships128,
				className: 'startingPointsThumb',
				type: 'startingPoints'
			}
		];

		const excluded = this.props.excluded;
		excluded.length > 0 && excluded.push('separator', 'label'); // removing separator and label

		return this._excludeTypes(spec, excluded).map((item, index) => this.renderItem(item, index)) || [];
	}

	_excludeTypes(spec, excludedTypes) {
		return this.props.excluded.length > 0 && spec.filter((item) => excludedTypes.indexOf(item.type) === -1) || spec;
	}
}

AddNewCard.propTypes = {
	onClick: PropTypes.func,
	excluded: PropTypes.array
};

AddNewCard.defaultProps = {
	onClick: () => {},
	excluded: []
};

export default AddNewCard;



// WEBPACK FOOTER //
// ./src/js/components/cards/AddNewCard.js